import React from 'react';
import { getPeAndPbRatio } from "api/urls";
import GraphContainer from 'components/wrapper/GraphContainer';


const PeAndPbChart = (props) => {

    const xkey = 'as_on_date'
    const tabs = [
        { title: "PE Chart", field: 'pe_ratio' },
        { title: "PB Chart", field: 'pb_ratio' }
    ]

    const setUrl = (type, company__symbol) => {
        let url = getPeAndPbRatio(type, company__symbol)
        return { url }
    }

    return (
        <div  {...props}>
            <GraphContainer
                setUrl={setUrl}
                tabs={tabs}
                xkey={xkey}
            />
        </div>
    )
};

export default (PeAndPbChart);